import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import Map from './pages/Map';
import Projects from './pages/Projects';
import ProjectDetails from './pages/ProjectDetails';
//import SiteConfiguration from './pages/SiteConfiguration';
import Units from './pages/Units';
import SiteConfig from './pages/SiteConfig';
import AccessControl from './pages/AccessControl';
import ProjectChargingSessions from './pages/ProjectChargingSessions';
import BillingInvoices from './pages/BillingInvoices';
import Chargers from './pages/Chargers';
import ChargerDetails from './pages/ChargerDetails';
import ChargerDashboard from './pages/ChargerDashboard';
import ChargerAlarmsEvents from './pages/ChargerAlarmsEvents';
import ChargerAccessControl from './pages/ChargerAccessControl';
import ChargerChargingSessions from './pages/ChargerChargingSessions';
import Switchboards from './pages/Switchboards';
import EnergyMeters from './pages/EnergyMeters';
import Excavators from './pages/Excavators';
import MachineDetails from './pages/MachineDetails';
import MachineDashboard from './pages/MachineDashboard';
import MachineAlarmsEvents from './pages/MachineAlarmsEvents';
import MachineChargingSessions from './pages/MachineChargingSessions';
import Users from './pages/Users';
import Companies from './pages/Companies';
import Login from './pages/Login';
import OrganizationSelection from './pages/OrganizationSelection';
import ProtectedRoute from './components/ProtectedRoute';
import OrganizationTest from './components/OrganizationTest';
import { BreadcrumbProvider } from './contexts/BreadcrumbContext';
import { AuthProvider } from './contexts/AuthContext';
import { SidebarProvider } from './contexts/SidebarContext';
import { theme } from './theme';
import './App.css';
import './styles/typography.css';

// LocatorJS for development
import Locator from '@locator/runtime';

function App() {
  React.useEffect(() => {
    // Check if we're in development mode (Create React App sets this)
    if (process.env.NODE_ENV === 'development') {
      // Initialize LocatorJS with explicit configuration
      Locator({
        adapter: 'react',
        projectPath: __dirname
      });
    }
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <AuthProvider>
          <BreadcrumbProvider>
            <SidebarProvider>
              <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/organization-selection" element={
                <ProtectedRoute>
                  <OrganizationSelection />
                </ProtectedRoute>
              } />
              <Route path="/organization/:orgId/*" element={
                <ProtectedRoute>
                  <Layout>
                    <Routes>
                      <Route path="/" element={<Navigate to="map" replace />} />
                      <Route path="/map" element={<Map />} />
                      <Route path="/projects" element={<Projects />} />
                      <Route path="/assets/chargers" element={<Chargers />} />
                      <Route path="/assets/chargers/:unitId" element={<ChargerDetails />}>
                        <Route index element={<Navigate to="dashboard" replace />} />
                        <Route path="dashboard" element={<ChargerDashboard />} />
                        <Route path="alarms" element={<ChargerAlarmsEvents />} />
                        <Route path="access-control" element={<ChargerAccessControl />} />
                        <Route path="charging-sessions" element={<ChargerChargingSessions />} />
                      </Route>
                      <Route path="/assets/switchboards" element={<Switchboards />} />
                      <Route path="/assets/energy-meters" element={<EnergyMeters />} />
                      <Route path="/assets/excavators" element={<Excavators />} />
                      <Route path="/assets/excavators/:unitId" element={<MachineDetails />}>
                        <Route index element={<Navigate to="dashboard" replace />} />
                        <Route path="dashboard" element={<MachineDashboard />} />
                        <Route path="alarms" element={<MachineAlarmsEvents />} />
                        <Route path="charging-sessions" element={<MachineChargingSessions />} />
                      </Route>
                      <Route path="/admin/users" element={<Users />} />
                      <Route path="/admin/companies" element={<Companies />} />
                      <Route path="/projects/:projectId" element={<ProjectDetails />}>
                        <Route index element={<Navigate to="assets" replace />} />
                        <Route path="assets" element={<Units />} />
                        <Route path="site-config" element={<SiteConfig />} />
                        <Route path="access-control" element={<AccessControl />} />
                        <Route path="charging-sessions" element={<ProjectChargingSessions />} />
                        <Route path="billing-invoices" element={<BillingInvoices />} />
                      </Route>
                      <Route path="/test-organization" element={<OrganizationTest />} />
                    </Routes>
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/*" element={<ProtectedRoute><Navigate to="/organization-selection" replace /></ProtectedRoute>} />
              </Routes>
            </SidebarProvider>
          </BreadcrumbProvider>
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App;